import React from 'react';
import { Button, Divider } from 'antd';
import constants from '../../../constants/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { getColorClass } from '../../../functions/functions';
import { ArrowLeftOutlined } from '@ant-design/icons';
import VideoHlsPlayer from './VideoHlsPlayer';
import { COOKIE, getCookie } from '../../../services/cookie';
import { handleKeyboardAction } from '../../../globalFunctions/GlobalFunctions';

const VideoComponent = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const videoDetails = location?.state

	const handleBackButton = () => {
		let path;
		let state;
		if(videoDetails?.chapter_id){
			path = "/chapter-resources";
			state = { chapter_id : videoDetails?.chapter_id }
		}else{
			path = "/video-resources";
			state = ""
		}
		navigate(path, { state: state })
	};

	return (
		<div className='container mx-auto'>
			<div className='flex justify-between items-center flex-wrap'>
				<h1 style={{ color: getColorClass("1", "colorcode") }} className='text-2xl underline underline-offset-4 font-extrabold uppercase m-0'>{location.state?.videoName}</h1>
				<Button onKeyDown={(event) => handleKeyboardAction(event, () => handleBackButton())}  onClick={() => handleBackButton()} icon={<ArrowLeftOutlined aria-hidden="true"/>} className='rounded-lg bg-blue-700 text-white'>{videoDetails?.chapter_id ? constants.BackToChapter : constants.BckVideos}</Button>
			</div>
			<Divider className='my-2' />
				{videoDetails?.filename && (
					<VideoHlsPlayer videoDetails={videoDetails} apiUrl={`${constants.ApiUrl}/get-video-chunk/${getCookie(COOKIE.UserId)}/${videoDetails?.videoId}`}/>
				)}
		</div>
	);
};

export default VideoComponent;
